import { useState, useEffect } from "react";
import { MdOutlineStoreMallDirectory } from "react-icons/md";

const Blob = () => {
  const [merchantDetails, setMerchantDetails] = useState(null);
  const [merchantThemeData, setMerchantThemeData] = useState(null);
  const [showPlaceholderIcon, setShowPlaceholderIcon] = useState(false);
  const emptyBanner = "https://payments.ipaygh.com/app/webroot/img/stores/null";
  const defaultImg = `url("${process.env.PUBLIC_URL}/svgs/gift.svg")`;

  const fetchMerchantDetails = async () => {
    try {
      const merchant = sessionStorage.getItem("MERCHANT");
      const merchantTheme = sessionStorage.getItem("MERCHANT_THEME");
      console.log("Somethinh");
      if (merchantTheme) {
        const merchantThemeParsed = JSON?.parse(merchantTheme);
        setMerchantThemeData(merchantThemeParsed);
      }
      if (merchant) {
        setMerchantDetails(JSON?.parse(merchant));
      }
    } catch (error) {
      console.error("Error fetching merchant details:", error);
    }
  };

  useEffect(() => {
    fetchMerchantDetails();
  }, []);
  return (
    <div className="hidden lg:flex flex-1 relative overflow-hidden min-h-screen justify-center items-center">
      <div
        className={`absolute inset-0 ${
          merchantThemeData?.theme || "bg-brandBlue"
        } z-0`}
        style={{
          backgroundColor: merchantThemeData?.theme,
          backgroundImage:
            merchantThemeData?.auth_banner !== emptyBanner
              ? `url("${merchantThemeData?.auth_banner}")`
              : defaultImg,
          backgroundSize:
            merchantThemeData?.auth_banner !== emptyBanner
              ? "cover"
              : "500px 500px",
          backgroundPosition:
            merchantThemeData?.auth_banner !== emptyBanner ? "center" : "",
          opacity: 0.9,
        }}
      ></div>

      <div
        className={`absolute inset-0 bg-repeat z-10 ${
          merchantThemeData?.auth_banner !== emptyBanner
            ? "bg-black bg-opacity-30"
            : ""
        }`}
        style={{
          backgroundImage: merchantThemeData?.auth_banner ? "" : defaultImg,
          backgroundSize: "500px 500px",
        }}
      />

      <div className="absolute inset-0 bg-black-900 bg-opacity-50 z-0"></div>

      <div className="w-full text-center flex flex-col items-center z-10 relative py-12">
        <div className="w-32 h-32 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden border-2 border-gray-200 mb-4">
          {!showPlaceholderIcon && merchantDetails?.merchant_logo ? (
            <img
              src={merchantDetails.merchant_logo}
              alt={merchantDetails.merchant_name}
              className="w-full h-full object-cover"
              onError={(e) => setShowPlaceholderIcon(true)}
            />
          ) : (
            <MdOutlineStoreMallDirectory
              size={50}
              color={merchantThemeData?.theme}
              className={` ${merchantThemeData?.theme || "text-gray-500"}`}
            />
          )}
        </div>
        <h2 className="text-3xl font-extrabold mb-3 tracking-tight text-white-A700 drop-shadow">
          {merchantDetails?.merchant_name}
        </h2>
        <p className="text-white-A700 text-center mb-6">
          Join our loyalty program today and start earning rewards with every
          purchase!
        </p>
      </div>
    </div>
  );
};

export default Blob;
